<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { sortByKey } from "lib/modules/util";

const props = defineProps({
	class: String,
	style: String,
	innerClass: {
		type: String,
		default: ""
	},
	innerStyle: String,
	capitalize: Boolean,
	optional: Boolean,
	options: [Array, Object],
	optionText: String,
	optionValue: String,
	error: String,
	label: String,
	placeholder: String,
	sort: Boolean,
	tooltip: String,
	modelValue: [String, Number, Object]
});

const emit = defineEmits(["update:modelValue"]);
const select = ref(null);

const selectValue = computed({
	get() {
		return props.modelValue === null || typeof props.modelValue === "undefined" ? "" : props.modelValue;
	},
	set(val) {
		emit("update:modelValue", val);
	}
});

const optionsArray = computed(() => {
	const options = [];

	props.options.forEach((option) => {
		const value = typeof props.optionValue === "undefined" ? option : option[props.optionValue];
		const text = typeof props.optionText === "undefined" ? option : option[props.optionText];

		options.push({ text, value });
	});

	if (props.sort)
		return sortByKey(options, "text");

	return options;
});

watchEffect(() => {
	if (select.value)
		select.value.setCustomValidity(typeof props.error !== "undefined" ? props.error : "");
});
</script>

<template>
	<label :class="class" :style="style" class="vui-select">
		<template v-if="label">
			<span class="label">{{ label }}</span>
			<span v-if="optional" class="badge">{{ $gettext("optional") }}</span>
			<i v-if="tooltip || $slots.tooltip" class="fa-solid fa-square-info tooltip tooltip-right" @click.prevent>
				<div class="tooltip-content"><slot name="tooltip">{{ tooltip }}</slot></div>
			</i>
		</template>
		<select
			ref="select"
			v-model="selectValue"
			v-bind="$attrs"
			:class="[{ capitalize, unselected: placeholder && selectValue === '' }, innerClass]"
			:style="innerStyle"
		>
			<option v-if="placeholder && selectValue === ''" value="" selected disabled>{{ placeholder }}</option>
			<slot>
				<option
					v-for="option in optionsArray"
					:value="option.value"
					:class="{ capitalize }"
				>
					{{ option.text }}
				</option>
			</slot>
		</select>
	</label>
</template>
